module.exports = __webpack_public_path__ + "static/RiskOfRain0-42779574b5862ea79ab02c12d70b6729.png";